import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const SeparatorLabel = styled.div.withConfig({ componentId: 'sc-rdfy5a-0' })`
    display: flex;
    align-items: center;
    gap: ${size(1)};
    font-size: var(--font-size-xsmall-static);
    font-weight: var(--font-weight-regular);
    color: var(--c-text-muted);
    text-align: center;
    overflow-wrap: break-word;
    hyphens: auto;

    &::before,
    &::after {
        content: "";
        flex: 1 1 ${size(8)};
        height: 1px;
        background-color: var(--c-border-main);
    }
`;
